import React, { useEffect, useState } from 'react';
import PaymentGateway from '../payment/PaymentGateway';
import CVHistoryModal from './CVHistoryModal';
import { API_URL } from '../../services/api';

interface BuilderModalsProps {
    showPaymentModal: boolean;
    setShowPaymentModal: (show: boolean) => void;
    showHistoryModal: boolean;
    setShowHistoryModal: (show: boolean) => void;
    savedCVId: string | null;
    amount?: number;
    templateId?: string;
    templateName?: string;
    onSave: (showNotification: boolean) => Promise<string | null>;
    onSuccessPayment: () => void;
    onSelectCV: (id: string) => void;
    onNewCV: () => void;
}

const BuilderModals: React.FC<BuilderModalsProps> = ({
    showPaymentModal,
    setShowPaymentModal,
    showHistoryModal,
    setShowHistoryModal,
    savedCVId,
    amount: amountProp = 750,
    templateId,
    templateName,
    onSave,
    onSuccessPayment,
    onSelectCV,
    onNewCV
}) => {
    const [amount, setAmount] = useState(amountProp);

    useEffect(() => {
        if (amountProp > 0) setAmount(amountProp);
    }, [amountProp]);

    useEffect(() => {
        if (!showPaymentModal) return;
        fetch(`${API_URL}/payment/methods`)
            .then((r) => r.json())
            .then((data) => {
                if (data?.amount && Number(data.amount) > 0) setAmount(Number(data.amount));
            })
            .catch(() => undefined);
    }, [showPaymentModal]);

    return (
        <>
            {showPaymentModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="relative max-w-3xl w-full">
                        <PaymentGateway
                            cvId={savedCVId || ''}
                            amount={amount}
                            templateId={templateId}
                            templateName={templateName}
                            onClose={() => setShowPaymentModal(false)}
                            onSuccess={() => {
                                onSuccessPayment();
                            }}
                            onSave={() => onSave(false)}
                        />
                    </div>
                </div>
            )}

            <CVHistoryModal
                isOpen={showHistoryModal}
                onClose={() => setShowHistoryModal(false)}
                onSelectCV={onSelectCV}
                onNewCV={onNewCV}
            />
        </>
    );
};

export default BuilderModals;
